const bimg = (id, crop = "entropy", w = 1400) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop&crop=${crop}`;

const D1 = bimg("photo-1596178060671-7a80dc8059ea");
const D2 = bimg("photo-1596178060671-7a80dc8059ea", "top");
const F1 = bimg("photo-1509423350716-97f9360b4e09");
const L1 = bimg("photo-1519710164239-da123dc03ef4", "bottom");

export const HEAD_POSTS = [
  {
    slug: "massage-for-tension-headaches",
    title: "Massage for Tension Headaches",
    keyword: "massage for tension headaches",
    category: "Headache, TMJ & Stress",
    read: "4 min read",
    img: D1,
    excerpt:
      "The band of pressure around the skull usually starts in the neck and shoulders. How massage addresses tension headaches at their source.",
    body: [
      {
        p: [
          "Tension headaches feel like a tight band around the head — pressure at the temples, the forehead, the base of the skull. Their most common fuel is not in the head at all: it is the sustained contraction of the neck, jaw and upper shoulder muscles, hour after desk-bound hour.",
        ],
      },
      {
        h: "Where a session works",
        p: [
          "The suboccipital muscles at the skull's base — a classic headache trigger zone — the temples and jaw, the length of the neck, and the upper traps. Releasing this chain reduces both the frequency and the intensity of tension headaches for many clients, often noticeably within a few sessions.",
        ],
      },
      {
        h: "Between sessions",
        p: [
          "Screen height, jaw unclenching (teeth apart, lips closed), and short neck resets through the day starve the headache of its fuel. Hydration and regular meals matter more than most expect.",
        ],
      },
    ],
    note:
      "A sudden, severe “worst of my life” headache, or headache with vision changes, weakness or confusion, is an emergency — not a massage booking. Chronic daily headaches deserve a physician's evaluation.",
  },
  {
    slug: "massage-therapy-for-migraines",
    title: "Can Massage Therapy Help with Migraines?",
    keyword: "massage therapy for migraines",
    category: "Headache, TMJ & Stress",
    read: "4 min read",
    img: D2,
    excerpt:
      "Migraine is a neurological condition — massage does not treat it. But for many people it softens the muscular triggers around it. The honest picture.",
    body: [
      {
        p: [
          "An honest answer first: migraine is a neurological condition, and massage does not treat it. What massage can address is one of its most common accomplices — the neck, jaw and shoulder tension that many migraine sufferers recognize as part of their prodrome, their trigger pattern, or their aftermath.",
        ],
      },
      {
        h: "What clients commonly report",
        p: [
          "Regular gentle neck and shoulder work — between attacks, never during one — is associated in many clients' experience with fewer tension-triggered episodes and shorter recovery muscular “hangover” after them. Research supports massage as a reasonable complementary approach, with the caveat that migraine is individual and results vary.",
        ],
      },
      {
        h: "How sessions are adapted",
        p: [
          "For migraine-prone clients: moderate pressure, no abrupt neck work, a calm low-stimulation room, and careful attention to anything that historically triggers an attack. Massage during an active migraine is usually not comfortable — reschedule without hesitation.",
        ],
      },
    ],
    note:
      "Migraines belong in a physician's care — especially if their pattern changes, worsens, or appears suddenly after forty. Massage is a complement to that care, not a replacement.",
  },
  {
    slug: "tmj-massage-edmonton",
    title: "TMJ Massage in Edmonton: Relief for Jaw Pain and Tension",
    keyword: "TMJ massage Edmonton",
    category: "Headache, TMJ & Stress",
    read: "4 min read",
    img: D1,
    excerpt:
      "The jaw works thousands of times a day and clenches through the night. What TMJ dysfunction feels like and how massage approaches it.",
    body: [
      {
        p: [
          "The temporomandibular joint is one of the busiest joints in the body — talking, chewing, swallowing, yawning — and for many people it also absorbs the night shift: clenching and grinding through stress. TMJ dysfunction shows up as jaw pain or fatigue, clicking, morning headaches, ear-area pain, and sometimes teeth that ache without a dental cause.",
        ],
      },
      {
        h: "What a TMJ session includes",
        p: [
          "Work begins externally: the masseter and temporalis muscles (the chewing powerhouses you can feel at the cheeks and temples), the muscles under the jaw, and always the neck — jaw and neck tension are inseparable. When appropriate and with your consent, gentle intraoral work with a gloved hand reaches the muscles no external technique can touch.",
        ],
      },
      {
        h: "What clients notice",
        p: [
          "Easier chewing, a quieter morning jaw, fewer tension headaches. Results often come quickly — the jaw muscles respond gratefully to finally being addressed directly.",
        ],
      },
    ],
    note:
      "Jaw locking, inability to open fully, or pain after dental work or injury should be assessed by your dentist or physician first. Massage complements dental care for TMJ issues — it does not replace it.",
  },
  {
    slug: "what-happens-during-tmj-massage",
    title: "What Happens During a TMJ Massage Session",
    keyword: "what happens during TMJ massage",
    category: "Headache, TMJ & Stress",
    read: "3 min read",
    img: D2,
    excerpt:
      "A step-by-step of a TMJ session, so the first one holds no surprises — from the neck up, at your pace, with consent at every step.",
    body: [
      {
        p: [
          "A TMJ session sounds more unusual than it feels. Knowing the sequence makes the first visit easy.",
        ],
      },
      {
        h: "The sequence",
        p: [
          "A short conversation first: where the jaw bothers you, clicking, grinding, headaches. Then external work — the temples, the chewing muscles at the cheeks and angle of the jaw, under the jawline, and the neck and shoulders that feed the pattern. Pressure is slow and moderate; the jaw is sensitive and responds to patience.",
        ],
      },
      {
        h: "If intraoral work is suggested",
        p: [
          "For many TMJ patterns the most effective muscles sit inside the mouth. This work is done with a gloved hand, gentle finger pressure on specific muscles for short holds, and always with your explicit consent — you can decline it and still have a fully useful session. Most clients describe it as strange for five seconds, then profoundly relieving.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "intraoral-tmj-massage",
    title: "Intraoral TMJ Massage: Is It Safe and What to Expect",
    keyword: "intraoral TMJ massage",
    category: "Headache, TMJ & Stress",
    read: "4 min read",
    img: L1,
    excerpt:
      "Working inside the mouth sounds clinical — and it is, in the good way. Hygiene, consent, technique, and why it reaches what nothing else can.",
    body: [
      {
        p: [
          "Intraoral massage means working on the jaw muscles from inside the mouth — specifically the lateral pterygoid and the inner fibres of the masseter, which no external technique can reach. For certain TMJ patterns it is the difference between managing symptoms and addressing the source.",
        ],
      },
      {
        h: "Safety and hygiene",
        p: [
          "The work is performed with a fresh gloved hand, clean technique, and clear communication throughout. Pressure is gentle and held for short intervals — these are small muscles that respond to precision, not force. It is standard practice in TMJ-focused massage therapy worldwide.",
        ],
      },
      {
        h: "What it feels like",
        p: [
          "Brief strangeness, then a deep, specific release — many clients feel tension headaches ease during the work itself. You remain in control throughout: consent is explicit, and the session is fully effective even if you prefer external work only.",
        ],
      },
    ],
    note:
      "Intraoral work is postponed with any mouth infection, recent dental surgery, or open sores — mention dental history when booking.",
  },
  {
    slug: "massage-for-clicking-jaw",
    title: "Massage for a Clicking or Popping Jaw",
    keyword: "massage for clicking jaw",
    category: "Headache, TMJ & Stress",
    read: "3 min read",
    img: D1,
    excerpt:
      "A jaw that clicks is usually a muscular timing problem before it is a joint problem. When massage helps the click — and when it is dental territory.",
    body: [
      {
        p: [
          "Jaw clicking happens when the small disc inside the TMJ shifts slightly out of step with the joint's movement. Far more often than not, the reason is muscular: the chewing muscles on one side pulling harder or earlier than the other, nudging the disc off its track.",
        ],
      },
      {
        h: "What massage addresses",
        p: [
          "Rebalancing the chewing muscles — releasing the overworking side, waking the lazy side — often quiets a painless click substantially. Sessions work the masseter, temporalis and pterygoids, plus the neck that anchors them.",
          "A painless click that comes and goes is usually benign. A click that comes with pain, catching or locking deserves dental assessment first.",
        ],
      },
    ],
    note:
      "Jaw locking — open or closed — or pain with the click should be evaluated by a dentist or physician before massage.",
  },
  {
    slug: "massage-for-teeth-grinding",
    title: "Massage for Teeth Grinding and Clenching (Bruxism)",
    keyword: "massage for teeth grinding",
    category: "Headache, TMJ & Stress",
    read: "4 min read",
    img: D2,
    excerpt:
      "Bruxism is the night's echo of the day's stress. Massage releases the overbuilt jaw muscles — while the mouthguard protects the teeth.",
    body: [
      {
        p: [
          "Grinding and clenching — bruxism — is the jaw doing stress work while you sleep. The signs are unmistakable: a tired, tight jaw in the morning, headaches at the temples, and over years, masseter muscles so developed they widen the jawline.",
        ],
      },
      {
        h: "What a session does",
        p: [
          "Deep, patient release of the masseter and temporalis muscles — externally and, with consent, intraorally — plus the neck and shoulders where the daytime clenching lives. Clients commonly report easier mornings and fewer temple headaches within the first few sessions.",
        ],
      },
      {
        h: "The division of labour",
        p: [
          "Massage releases the muscles; it does not protect the teeth. If you grind at night, a dental mouthguard is still essential — the two work as a team: the guard saves your enamel, the massage saves your jaw.",
        ],
      },
    ],
    note:
      "If you suspect you grind your teeth, see your dentist about a guard in parallel with massage care — tooth wear is irreversible.",
  },
  {
    slug: "neck-tension-tmj-headache",
    title: "The Neck–Jaw–Headache Triangle: How They Feed Each Other",
    keyword: "neck tension TMJ headache",
    category: "Headache, TMJ & Stress",
    read: "4 min read",
    img: D1,
    excerpt:
      "Neck tension, jaw clenching and headaches rarely travel alone. Understanding the triangle explains why treating one often quiets all three.",
    body: [
      {
        p: [
          "These three complaints share anatomy. The jaw muscles attach around a joint that sits next to the ear; the neck muscles that hold your head attach at the skull's base, centimetres away; and the nerves that refer pain overlap generously. Tension in one corner of the triangle recruits the other two.",
        ],
      },
      {
        h: "A typical loop",
        p: [
          "A long screen day tightens the neck. The jaw clenches in concentration. By evening, the suboccipitals at the skull's base join in — and the result is tomorrow morning's headache, worn jaw and stiff neck arriving as one package. Treating only the headache leaves the engine running.",
        ],
      },
      {
        h: "Why sessions address all three",
        p: [
          "A session for any one of these complaints at Royal Essence includes the other two by default. It is not thoroughness for its own sake — it is simply how the triangle unwinds. Clients are often surprised that their “jaw problem” improves most when the neck finally lets go.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-for-stress-relief",
    title: "Massage for Stress and Anxious Tension",
    keyword: "massage for stress relief",
    category: "Headache, TMJ & Stress",
    read: "4 min read",
    img: F1,
    excerpt:
      "Stress lives in the body before it reaches the mind. How a session downshifts the nervous system — and why regularity beats intensity.",
    body: [
      {
        p: [
          "Stress is not only a feeling — it is a posture: shoulders lifted, jaw set, breath shallow, muscles quietly braced for a threat that is actually an inbox. The body holds the alarm long after the mind has moved on.",
        ],
      },
      {
        h: "What a session changes",
        p: [
          "Slow, rhythmic, warm work signals safety to the nervous system more directly than any thought can. Heart rate drops, breathing deepens, the braced muscles release — often within the first fifteen minutes. Many clients describe it as the first time all week their body was not waiting for something.",
        ],
      },
      {
        h: "Why regularity matters",
        p: [
          "A single session resets the system; regular sessions retrain its baseline. A monthly or bi-weekly appointment keeps the default state closer to calm — so the next hard week starts from settled, not from braced. This is the quiet logic behind “a space to exhale.”",
        ],
      },
    ],
    note:
      "Massage supports stress management beautifully, but persistent anxiety or low mood deserve professional mental-health care — the two work well together.",
  },
  {
    slug: "massage-for-better-sleep",
    title: "Does Massage Help You Sleep Better?",
    keyword: "massage for better sleep",
    category: "Headache, TMJ & Stress",
    read: "3 min read",
    img: L1,
    excerpt:
      "Many clients report their best sleep in weeks on the night after a session. Why massage and sleep are such natural allies.",
    body: [
      {
        p: [
          "Ask regular massage clients about sleep and a pattern emerges: the night after a session is often unusually deep. There is physiology behind the anecdote.",
        ],
      },
      {
        h: "Why it works",
        p: [
          "Massage shifts the nervous system toward its rest-and-digest mode — slower heart rate, lower cortisol, deeper breathing. It also removes the physical static that keeps light sleepers at the surface: the aching shoulder, the restless legs, the jaw that never quite unclenches. A body that is comfortable and calm simply sleeps better.",
        ],
      },
      {
        h: "Making the most of it",
        p: [
          "Book later in the day when you can — an evening session followed by a quiet night is the classic recipe. And protect the calm afterwards: screens off early, bed on time. The massage opens the door; the evening decides whether you walk through.",
        ],
      },
    ],
    note:
      "Chronic insomnia or loud snoring with pauses in breathing (possible sleep apnea) need medical evaluation — massage complements, not replaces, that care.",
  },
];
